import { z } from 'zod'

export const createScriptSchema = z.object({
  name: z.string().min(1, 'Script name is required').max(100, 'Script name must be less than 100 characters'),
  dslCode: z.string().optional(), // Allow creating empty scripts
})

export const updateScriptSchema = z.object({
  name: z.string().min(1).max(100).optional(),
  dslCode: z.string().min(1).optional(),
})

export type CreateScriptInput = z.infer<typeof createScriptSchema>
export type UpdateScriptInput = z.infer<typeof updateScriptSchema>
